import React, { useState } from "react";
import { FaPlus, FaTrashAlt, FaUserCircle } from "react-icons/fa";
import Select from "react-select";

const ApproversSetup = ({ approvers, onChange, options }) => {
  const [approverType] = useState("Specific");

  const addApprover = () => {
    onChange([...approvers, { approver: null, amount: "", currency: "INR" }]);
  };

  const updateApprover = (index, updatedApprover) => {
    const updatedApprovers = approvers.map((approver, i) =>
      i === index ? updatedApprover : approver
    );
    onChange(updatedApprovers);
  };

  const deleteApprover = (index) => {
    const updatedApprovers = approvers.filter((_, i) => i !== index);
    onChange(updatedApprovers);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Approvers Setup</h2>

      {approverType === "Specific" && (
        <div className="space-y-6">
          {approvers.map((approver, index) => (
            <div
              key={index}
              className="p-4 bg-gray-100 rounded-lg shadow-md border space-y-4"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                <div className="flex items-center space-x-4">
                  <FaUserCircle className="text-4xl text-gray-500" />
                  <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700">
                      Approver
                    </label>
                    <Select
                      options={options}
                      value={approver.approver}
                      onChange={(selectedOption) =>
                        updateApprover(index, {
                          ...approver,
                          approver: selectedOption,
                        })
                      }
                      placeholder="Search and select User or Group"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-center">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Amount
                  </label>
                  <input
                    type="number"
                    value={approver.amount}
                    onChange={(e) =>
                      updateApprover(index, {
                        ...approver,
                        amount: e.target.value,
                      })
                    }
                    className="w-full border px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter amount"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Currency
                  </label>
                  <select
                    value={approver.currency}
                    onChange={(e) =>
                      updateApprover(index, {
                        ...approver,
                        currency: e.target.value,
                      })
                    }
                    className="w-full border px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="INR">INR</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="JPY">JPY</option>
                  </select>
                </div>
                <div className="flex justify-end">
                  <button
                    onClick={() => deleteApprover(index)}
                    className="text-red-500 hover:text-red-600 flex items-center space-x-2"
                  >
                    <FaTrashAlt />
                    <span>Remove</span>
                  </button>
                </div>
              </div>
            </div>
          ))}

          <button
            onClick={addApprover}
            className="flex items-center space-x-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition focus:ring-2 focus:ring-blue-500"
          >
            <FaPlus />
            <span>Add Approver</span>
          </button>

          {/* Additional Options */}
          <div className="space-y-4 mt-6 border-t pt-4">
            <label className="block text-sm text-gray-600">
              <input type="checkbox" className="mr-2" />
              Skip requester and everyone before them if they are also a
              specific approver.
            </label>
            <label className="block text-sm text-gray-600">
              <input type="checkbox" className="mr-2" />
              Skip original requester's management hierarchy if Invoice meets
              this approval chain.
            </label>
            <label className="block text-sm text-gray-600">
              <input type="checkbox" className="mr-2" />
              Skip all Approval Chains after this one (keep management
              hierarchy, budget checks, exception handling, Ultimate Approvers).
            </label>
            <label className="block text-sm text-gray-600">
              <input type="checkbox" className="mr-2" />
              Automatically self-approve if requester.
            </label>
            <label className="block text-sm text-gray-600">
              <input type="checkbox" className="mr-2" />
              Enable Parallel Approvals.
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApproversSetup;
